var map = {
	"./accounting-finance.jpg": 364,
	"./administrative-clerical.jpg": 40496,
	"./agriculture-fishing-forestry.jpg": 82689,
	"./basic-computer-skills.jpg": 39203,
	"./business-strategic-management.jpg": 5853,
	"./community-and-social-services-non-profits.jpg": 90742,
	"./computers-software-development.jpg": 79234,
	"./construction.jpg": 73065,
	"./customer-support-client-care.jpg": 41182,
	"./design-arts.jpg": 92485,
	"./electrical-engineering.jpg": 87226,
	"./engineering-architecture.jpg": 10217,
	"./engineering.jpg": 23937,
	"./entertainment.jpg": 9386,
	"./food-processing-manufacturing.jpg": 26701,
	"./health-sports-beauty.jpg": 24805,
	"./high.jpg": 36950,
	"./human-resources.jpg": 92039,
	"./junior.jpg": 69981,
	"./kisumu.jpg": 71024,
	"./leadership-skills.jpg": 32232,
	"./legal.jpg": 62967,
	"./management-consulting-auditing-tax-consultancy.jpg": 52,
	"./manufacturing-operations-quality.jpg": 73435,
	"./material-processing.jpg": 33181,
	"./mechanical-engineering-metal-processing.jpg": 98383,
	"./media-communications-languages.jpg": 37090,
	"./medical-health.jpg": 73886,
	"./mid.jpg": 10366,
	"./mombasa.jpg": 48382,
	"./nairobi.jpg": 86730,
	"./people-skills.jpg": 86340,
	"./research-academy.jpg": 36284,
	"./restaurant-hospitality-travel.jpg": 69721,
	"./sales-marketing-promotion.jpg": 62119,
	"./security.jpg": 9364,
	"./skilled-manual-labor.jpg": 96200,
	"./teaching-training.jpg": 336,
	"./textile-clothing-leather-footwear-production.jpg": 55798,
	"./transportation-logistics-driving.jpg": 96944,
	"./work-discipline.jpg": 9314,
	"images/categories/accounting-finance.jpg": 364,
	"images/categories/administrative-clerical.jpg": 40496,
	"images/categories/agriculture-fishing-forestry.jpg": 82689,
	"images/categories/basic-computer-skills.jpg": 39203,
	"images/categories/business-strategic-management.jpg": 5853,
	"images/categories/community-and-social-services-non-profits.jpg": 90742,
	"images/categories/computers-software-development.jpg": 79234,
	"images/categories/construction.jpg": 73065,
	"images/categories/customer-support-client-care.jpg": 41182,
	"images/categories/design-arts.jpg": 92485,
	"images/categories/electrical-engineering.jpg": 87226,
	"images/categories/engineering-architecture.jpg": 10217,
	"images/categories/engineering.jpg": 23937,
	"images/categories/entertainment.jpg": 9386,
	"images/categories/food-processing-manufacturing.jpg": 26701,
	"images/categories/health-sports-beauty.jpg": 24805,
	"images/categories/high.jpg": 36950,
	"images/categories/human-resources.jpg": 92039,
	"images/categories/junior.jpg": 69981,
	"images/categories/kisumu.jpg": 71024,
	"images/categories/leadership-skills.jpg": 32232,
	"images/categories/legal.jpg": 62967,
	"images/categories/management-consulting-auditing-tax-consultancy.jpg": 52,
	"images/categories/manufacturing-operations-quality.jpg": 73435,
	"images/categories/material-processing.jpg": 33181,
	"images/categories/mechanical-engineering-metal-processing.jpg": 98383,
	"images/categories/media-communications-languages.jpg": 37090,
	"images/categories/medical-health.jpg": 73886,
	"images/categories/mid.jpg": 10366,
	"images/categories/mombasa.jpg": 48382,
	"images/categories/nairobi.jpg": 86730,
	"images/categories/people-skills.jpg": 86340,
	"images/categories/research-academy.jpg": 36284,
	"images/categories/restaurant-hospitality-travel.jpg": 69721,
	"images/categories/sales-marketing-promotion.jpg": 62119,
	"images/categories/security.jpg": 9364,
	"images/categories/skilled-manual-labor.jpg": 96200,
	"images/categories/teaching-training.jpg": 336,
	"images/categories/textile-clothing-leather-footwear-production.jpg": 55798,
	"images/categories/transportation-logistics-driving.jpg": 96944,
	"images/categories/work-discipline.jpg": 9314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90380;